<template>
<div>

<b-row class="text-center m-4 align-items-center">
    <b-col md="8">
        <h5><strong>{{$ml.get('visutoolt1')}}</strong></h5>

        <p style="text-align:justify" v-html="$ml.get('visutoolp1')"></p>

        <b-row class="justify-content-center align-items-center">
            <ol class="center" style="margin: 10px">
                <li style="margin-bottom:10px; text-align:justify">
                    {{$ml.get('visutoolli1')}}<br/>
                    <code>
                        {{line1_script}}
                    </code>
                    <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="copyToClipboard(line1_script)"/>
                </li>
                <li style="margin-bottom:10px; text-align:justify">
                     {{$ml.get('visutoolli2')}}<br/>
                    <code>
                        {{line2_script}}
                    </code>
                    <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="copyToClipboard(line2_script)"/>
                </li>
            </ol>
        </b-row>
        <p style="text-align:justify" v-html="$ml.get('visutoolp2')"></p>

        <h5 style="margin-top:2rem"><strong>{{$ml.get('visutoolt2')}}</strong></h5>
        
        <p style="text-align:justify"  v-html="$ml.get('visutoolp3')"></p>
        <code>
            {{line3_script}}
        </code>
        <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="copyToClipboard(line3_script)"/>
        
        <p style="text-align:justify; margin-top:1rem"  v-html="$ml.get('visutoolp4')"></p>
        <code>
            {{line4_script}}
        </code>
        <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="copyToClipboard(line4_script)"/>

        <p style="text-align:justify; margin-top:1rem" v-html="$ml.get('visutoolp5')"></p>
    </b-col>
    <b-col md="4">
        <b-img style="max-width:450px; border-radius:0.5rem" :src="require('@/assets/VisualizationTool/tool8.png')"></b-img>
    </b-col>
</b-row>

    <b-modal ref="copied" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>{{$ml.get('copied')}}</h3>
      </div>
      <p>{{$ml.get('selectedtextcopied')}}</p>
      <b-row class="justify-content-around">
          <b-btn class="col-md-3 col-5" variant="msstreamblue" block @click="cleanMyTimeout();hideModal('copied')">Ok</b-btn>
      </b-row>
    </b-modal>

</div>
</template>
<script>
import VueMarkdown from 'vue-markdown';
import Prism from 'prismjs';
import 'prismjs/themes/prism-twilight.css';
export default {
  name: 'VisualizationTool',
  data: function() {
    return {
        line1_script: '<script src="https://files.quanteec.com/vizualisation/latest/quanteec-visualize.min.js"><'+'/script>',
        line2_script: '<div id="quanteec-visualize-tool"></div>',
        line3_script: '<div id="quanteec-visualize-tool" style="font-size: 10px;"></div>',
        line4_script: '<div id="quanteec-visualize-tool" quanteecShow="less"></div>'
    }
  },
  components: {
      VueMarkdown
  },
  mounted: function() {

    this.$nextTick(() => {
        Prism.highlightAll()
      });  
  },
  methods: {
    cleanMyTimeout() {
      try {
        clearTimeout(this.timeout);
      } catch(err) {}
    },

    copyToClipboard(text) {
      this.cleanMyTimeout();
      this.$copyText(text);
      this.showModal("copied");
      this.timeout = setTimeout(this.hideModal, 1.5 * 1000, 'copied');
    },
    showModal(modal) {
      this.$refs[modal].show();
    },
    hideModal(modal) {
      this.$refs[modal].hide();
    },

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>